var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65332 12.4999C8.20653 12.4857 7.27052 12.11 7.25977 12.0927C5.74082 11.4785 2.81069 9.62432 1.45703 8.30267L1.06348 7.90619C0.96055 7.79872 0.844313 7.67138 0.772461 7.5722C0.532513 7.26601 0.413107 6.88664 0.413086 6.50775C0.413086 6.08492 0.547251 5.69164 0.801758 5.37006L1.20605 4.94916L1.29687 4.85931C2.52523 3.57602 5.73178 1.47802 7.40918 0.835876L7.66211 0.742126C7.96688 0.636845 8.39439 0.511505 8.65332 0.499939C8.98267 0.499957 9.29773 0.573306 9.59766 0.718689C9.97226 0.922475 10.2703 1.24508 10.4355 1.62396C10.5405 1.88559 10.7051 2.66854 10.7061 2.68744C10.8576 3.48155 10.9464 4.73511 10.959 6.13959L10.96 6.4931C10.96 7.96474 10.871 9.30697 10.7363 10.1816L10.6182 10.7255C10.5525 11.0135 10.4659 11.3414 10.376 11.5087C10.0466 12.1211 9.40219 12.4999 8.71289 12.4999H8.65332ZM13.6914 7.69135C13.0158 7.69121 12.4678 7.15747 12.4678 6.49994C12.468 5.84151 13.0159 5.30964 13.6914 5.30951L17.5303 4.98236C18.3914 4.98248 19.0896 5.66196 19.0898 6.49994C19.0898 7.33812 18.3916 8.01837 17.5303 8.01849L13.6914 7.69135Z",
    fill: "#9983FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftWithdraw);
export default __webpack_public_path__ + "static/media/left-withdraw.05c271162a96d9b7cd07f9c28f9ccb32.svg";
export { ForwardRef as ReactComponent };